goog.provide('yext.plugins.multiselect');

/**
 * @suppress {deprecated}
 * @param {!jQuery} $
 */
(function($) {
  var methods = {
    'init': function(options) {
      var settings = $.extend({
        title: yext.msg('Select an option'),
        theme: 'gray',
        header: '',
      }, options);

      return this.each(function() {
        // Create the button
        var $multiselect = $('<div>').addClass('multiselect');
        var $button = $('<button>').addClass('button-' + settings.theme + ' btn-dropdown');
        var $span = $('<span>');
        $span.text(settings.title);
        $button.append($span);
        $multiselect.append($button);
        $multiselect.addClass($(this).attr('class'));
        $(this).after($multiselect);
        $(this).hide();

        $button.click(function() {
          var $activeMultiselect = $('.multiselect-options').prev('button');

          var $parent = $(this).closest('.multiselect');
          if ($parent.hasClass('selected-state')) {
            $parent.removeClass('selected-state');
          } else {
            $('.multiselect.selected-state, .selectbox.selected-state').removeClass('selected-state');
            $(this).closest('.multiselect').addClass('selected-state');
          }
          // Remove any other visible multiselect options
          $('.multiselect-options').remove();
          $(document).unbind('.multiselect');

          // Clicking on an active multiselect should close it and do nothing else
          if ($activeMultiselect.get(0) == this) {
            return;
          }

          var $div = $('<div>').addClass('multiselect-options');
          var $arrow = $('<div>').addClass('select-arrow');
          $div.append($arrow);
          var $select = $('<div>').addClass('select');
          $select.append(settings.header);
          var $ul = $('<ul>');
          $select.append($ul);
          $(this).parent().prev('select').children('option').each(function() {
            var $li = $('<li>');
            $li.attr('class', $(this).attr('class'));
            var $label = $('<label>');
            var $input = $('<input type="checkbox">');
            $input.attr('value', $(this).attr('value'));
            if ($(this).is(':selected')) {
              $input.prop('checked', true);
            }
            $label.append($input);
            $label.append($('<span>').text($(this).text()));
            $li.append($label);
            $ul.append($li);
          });

          if (!settings.hideFooter) {
            // TRANSLATORS: Apply changes
            var $apply = $('<button class="button-orange apply"><span>' + yext.msg('Apply') + '</span></button>');
            $apply.click(function() {
              if (settings.apply) {
                settings.apply();
              }
              $('.multiselect-options').remove();
              $(document).unbind('.multiselect');
              return false;
            });
            $select.append($apply);

            var $cancel = $('<a class="cancel-multiselect" href="#">' + yext.msg('Cancel') + '</a>');
            $cancel.click(function() {
              $('.multiselect-options').remove();
              $(document).unbind('.multiselect');
              $('.multiselect').removeClass('selected-state');
              return false;
            });
            $select.append($cancel);
          }

          $div.append($select);
          $select.css('min-width', ($(this).width() - 2) + 'px');
          if (settings.width) {
            $select.css('width', settings.width);
          }
          $(this).parent().append($div);

          $select.position({
            'my': 'left top',
            'at': 'left bottom',
            'of': $div.parent(),
            'collision': 'flip flipfit',
            'offset': '0 3',
          });

          var height = 0;
          // $div.height() is 0, so sum height of children
          $div.children().each(function() {
            height += $(this).height();
          });
          if ($(document).height() - $div.offset().top - height < 30) {
            $select.addClass('invert');
            $arrow.addClass('invert');
          }

          // Click now to get the equivalent of returning true, but before we
          // bind a click handler that will close the selectbox
          $(document).click();

          // Close multiselect options on document click (outside multiselect) or escape
          $(document).bind('click.multiselect keydown.multiselect', function(e) {
            if ((e.type == 'click' && $(e.target).parents('.multiselect-options').length == 0)
                  || (e.type == 'keydown' && (e.keyCode == $.ui.keyCode.ESCAPE))) {
              $('.multiselect-options').remove();
              $('.multiselect').removeClass('selected-state');
              $(document).unbind('.multiselect');
            } else {
              // Not a handled action, so allow it to bubble (e.g., CMD+R / F5)
              return;
            }
            return false;
          });

          return false;
        });
      });
    },
    'close': function() {
      this.each(function() {
        $(this).next('.multiselect').find('.multiselect-options').remove();
      });
    },
  };

  $.fn.multiselect = function(method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods['init'].apply(this, arguments);
    }
  };
})(jQuery);
